namespace AgerLMS.LMS {
    export interface BundleRow {
        BundleId?: number;
        BundleName?: string;
        BundleDescription?: string;
        BundleType?: BundleTypes;
        CategoryId?: number;
        Price?: number;
        SalePrice?: number;
        Thumbnail?: string;
        CoverImage?: string;
        DemoVideoSource?: DemoVideoSources;
        DemoVideo?: string;
        Downloadable?: boolean;
        AccessPeriodDays?: number;
        Seo?: string;
        DisplayOrder?: number;
        CategoryCategoryName?: string;
        CategoryParentCategoryId?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace BundleRow {
        export const idProperty = 'BundleId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'BundleName';
        export const localTextPrefix = 'LMS.Bundle';
        export const lookupKey = 'LMS.Bundle';

        export function getLookup(): Q.Lookup<BundleRow> {
            return Q.getLookup<BundleRow>('LMS.Bundle');
        }
        export const deletePermission = 'LMS:Bundle:Modify';
        export const insertPermission = 'LMS:Bundle:Modify';
        export const readPermission = 'LMS:Bundle:Read';
        export const updatePermission = 'LMS:Bundle:Modify';

        export declare const enum Fields {
            BundleId = "BundleId",
            BundleName = "BundleName",
            BundleDescription = "BundleDescription",
            BundleType = "BundleType",
            CategoryId = "CategoryId",
            Price = "Price",
            SalePrice = "SalePrice",
            Thumbnail = "Thumbnail",
            CoverImage = "CoverImage",
            DemoVideoSource = "DemoVideoSource",
            DemoVideo = "DemoVideo",
            Downloadable = "Downloadable",
            AccessPeriodDays = "AccessPeriodDays",
            Seo = "Seo",
            DisplayOrder = "DisplayOrder",
            CategoryCategoryName = "CategoryCategoryName",
            CategoryParentCategoryId = "CategoryParentCategoryId",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
